import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Spinner } from './UI';

export function RequireAuth({ children, role }) {
  const { user, loading } = useAuth();

  if (loading) return (
    <div style={{ minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#0d0d1a' }}>
      <Spinner />
    </div>
  );

  if (!user) return <Navigate to="/login" replace />;

  if (role && user.role !== role) {
    return <Navigate to={user.role === 'superadmin' ? '/admin' : '/dashboard'} replace />;
  }

  return children;
}
